import React, { useEffect, useRef, useState } from "react";
import { TextBox } from "devextreme-react/text-box";
import { Button } from "devextreme-react/button";
import { Validator, CustomRule } from "devextreme-react/validator";

interface Props {
    value: string;
    onValueChanged: (trimmedValue: string) => void;
    readOnly?: boolean;
    editHint?: string;
    warningMessage?: string;
}

export default function TextBoxEditToggle(props: Props) {
    const readOnly = props.readOnly ?? false;
    const editHint = props.editHint ?? "Edit";
    const textBoxRef = useRef(null);

    const [isEditing, setIsEditing] = useState(false);
    const [internalValue, setInternalValue] = useState(props.value);

    useEffect(() => {
        setInternalValue(props.value);
    }, [props.value]);

    return (
        <div className="textbox-edit-toggle-container">
            <div className="textbox-edit-toggle-editor">
                <TextBox
                    onInitialized={(e) => {
                        textBoxRef.current = e.component;
                        e.component.focus();
                    }}
                    value={internalValue}
                    readOnly={readOnly || !isEditing}
                    onValueChanged={(e) => {
                        const trimmed = typeof e.value === "string" ? e.value.trim() : e.value;
                        setInternalValue(trimmed);
                        props.onValueChanged(trimmed);
                    }}
                    style={{ flex: 1 }}
                />

                {!readOnly && !isEditing && (
                    <div onMouseDown={(e) => e.preventDefault()}>
                        <Button
                            icon="edit"
                            stylingMode="text"
                            hint={editHint}
                            onClick={() => {
                                setIsEditing(true);
                                setTimeout(() => textBoxRef.current?.focus(), 0);
                            }}
                        />
                    </div>
                )}
            </div>
            {!readOnly && isEditing && props.warningMessage && (
                <div className="textbox-edit-toggle-message">
                    <i className="dx-icon-warning" />
                    <span>{props.warningMessage}</span>
                </div>
            )}
        </div>
    );
}